import { tech1, tech2, tech3, facebook, instagram, linkedin, twitter, airbnb, binance, coinbase, dropbox, send, shield, star  } from "../assets";

export const navLinks = [
  {
    id: "",
    title: "Home",
  },
  {
    id: "features",
    title: "Solutions",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "login",
    title: "Partner Login",
  },
];

export const features = [
  {
    id: "feature-1",
    icon: star,
    title: "B2C Advertising",
    content:
      "Targeting the right customers and converting visitors into buyers is one of the top challenges for real estate firms. We provide an active, always-on resolution network to strengthen customer segmentation, enhanced list building, and personalized customer buyer journeys, giving you visibility on who to target and how to tailor messaging to improve conversion.",
  },
  {
    id: "feature-2",
    icon: shield,
    title: "B2B Advertising",
    content:
      "The B2B advertising space over the years has transformed rapidly. Leverage our “Five Arb” approach to generate a predictable pipeline, understand individual and account buyer journeys, build a robust data-driven marketing strategy, and deliver a high ROI on your marketing budget.",
  },
  {
    id: "feature-3",
    icon: send,
    title: "Email Marketing",
    content:
      "Data is the backbone of any successful email marketing campaign. Exceed your data capabilities with the unification of your data, our data ecosystem, and Five By Five to achieve a holistic view of your customer and build enriched email lists. Steer away from generic email content hindering conversion, and take your email marketing to the next-level with our platform.",
  },
];

export const detailed_features = [
  {
    id: "feature-1",
    icon: star,
    title: "Data Co-Op",
    content:
      "Harness the power of unlimited first-party data at a fixed price to help build and accelerate your data capabilities.",
  },
  {
    id: "feature-2",
    icon: shield,
    title: "Resolution Network",
    content:
      "With our resolution pixel and endpoint technology, we have been able to identify millions of website visitors, enrich the data with over 100+ attributes, and supercharge our partner’s digital marketing campaigns.",
  },
  {
    id: "feature-3",
    icon: send,
    title: "Leverage Our Identity Graph",
    content:
      "We have built an identity graph across our ecosystem of strategic partners where we have established a single-pane customer view collecting and combining customer personal identifiers to complete a customer profile.",
  },
];

export const contact_info = [
  {
    id: "contact-1",
    icon: star,
    title: "Phone",
    content:
      "480-360-0074",
  },
];

export const feedback = [
  {
    id: "feedback-1",
    content: "We have created a predictable way to generate 5x the leads from your existing captive website traffic. Our ability to identify your traffic and enrich these prospects provides you with the ability to 5x your total number of leads.",
    name: "Lead Data Cloud",
    title: "LDC",
    img: tech2,
  },
  {
    id: "feedback-2",
    content: "If you want to control your audience activations for your programmatic ads, then we have a solution that can help with Audience Data Cloud (ADC).",
    name: "Audience Data Cloud",
    title: "ADC",
    img: tech3,
  },
  {
    id: "feedback-3",
    content: "Accelerate your top-of-funnel by leveraging our resolution network and identity graph to drive our Demand Side Platform (DSP). ",
    name: "Media Placement Cloud",
    title: "DSP",
    img: tech1,
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Records Processed",
    value: "5.71 Trillion",
  },
  {
    id: "stats-2",
    title: "Net New Prospects",
    value: "1.7 million",
  },
  {
    id: "stats-3",
    title: "Rows of Metadata/day",
    value: "25+ Billion",
  },
];

export const footerLinks = [
  {
    title: "Links",
    links: [
      {
        name: "Home",
        link: "https://www.fivebyfive.com",
      },
      {
        name: "Features",
        link: "https://www.fivebyfive.com/features",
      },
      {
        name: "Contact",
        link: "https://www.fivebyfive.com/contact",
      },
      {
        name: "Partner Login",
        link: "https://www.fivebyfive.com/login",
      }
    ],
  },
  {
    title: "Partners",
    links: [
      {
        name: "5x5",
        link: "https://www.join5x5.com",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/",
  },
];

export const clients = [
  {
    id: "client-1",
    logo: airbnb,
  },
  {
    id: "client-2",
    logo: binance,
  },
  {
    id: "client-3",
    logo: coinbase,
  },
  {
    id: "client-4",
    logo: dropbox,
  },
];